import { render } from "./LuckyNumberMarket.vue?vue&type=template&id=be5ff016"
import script from "./LuckyNumberMarket.vue?vue&type=script&lang=js"
export * from "./LuckyNumberMarket.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__